export default __webpack_public_path__ + "static/media/water.be72c5a6.svg";